import { FC, ReactNode, useState } from 'react'

import { Button, ButtonProps, InputAdornment, Stack } from '@mui/material'

import { ConsoleTextField } from '../StyledInputComponents'
import { ConsoleTextFieldProps } from '../StyledInputComponents/StyledFormComponents'

export const ADD_FIELDS_LABEL = 'Add fields'
export const FIELDS_AMOUNT_LABEL = 'Fields amount'

export const dynamicFieldLabel = (index: number) => `Field ${index + 1}` as const

interface DynamicFieldsListProps {
  values: string[]
  onChange: (value: string[]) => void
  onClear?: () => void
  formatListOption?: (index: number) => string
  fieldAmountTextFieldProps?: ConsoleTextFieldProps
  fieldAddedTextFieldProps?: ConsoleTextFieldProps
  addButtonProps?: ButtonProps
  addButtonLabel?: string
  endAdornment?: ReactNode
}

export const DynamicFieldsList: FC<DynamicFieldsListProps> = ({
  values,
  onChange,
  onClear,
  formatListOption,
  fieldAmountTextFieldProps,
  fieldAddedTextFieldProps,
  addButtonProps,
  addButtonLabel,
  endAdornment
}) => {
  const [fieldsToAdd, setFieldsToAdd] = useState(0)
  const [fieldsAdded, setFieldsAdded] = useState(0)
  const [fields, setFields] = useState(values)

  const clearRemovedFields = () => {
    handleOnChange(fields.slice(0, fieldsToAdd))
  }

  const handleOnChange = (newFields: string[]) => {
    setFields(newFields)
    onChange(newFields)
  }

  const handleSetFields = () => {
    setFieldsAdded(fieldsToAdd)
    clearRemovedFields()
    onClear?.()
  }

  const formatter = formatListOption || dynamicFieldLabel

  return (
    <>
      <Stack
        gap={1.3}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <ConsoleTextField
          label={FIELDS_AMOUNT_LABEL}
          placeholder={FIELDS_AMOUNT_LABEL}
          sx={{ flex: 1 }}
          required
          {...fieldAmountTextFieldProps}
          onChange={(e) => {
            const value = Number(e.target.value)
            if (!isNaN(value) && value >= 0) {
              setFieldsToAdd(value)
            }
          }}
          value={fieldsToAdd}
          type="number"
        />
        <Button
          sx={{
            height: 36.71,
            mt: 1,
            mb: 0.5
          }}
          {...addButtonProps}
          onClick={handleSetFields}
        >
          {addButtonLabel || ADD_FIELDS_LABEL}
        </Button>
      </Stack>
      <Stack justifyContent="space-between" alignItems="center" width="100%">
        {Array.from({ length: fieldsAdded }, (_, index) => (
          <Stack key={index} gap={1} width="100%" direction="row" alignItems="center">
            <ConsoleTextField
              type="text"
              sx={{ flex: 1 }}
              InputProps={{
                endAdornment: endAdornment && (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                )
              }}
              {...fieldAddedTextFieldProps}
              onChange={(e) => {
                const newFields = [...fields]
                newFields[index] = e.target.value
                handleOnChange(newFields)
              }}
              key={index}
              label={formatter(index)}
              placeholder={formatter(index)}
            />
          </Stack>
        ))}
      </Stack>
    </>
  )
}
